import React, { useEffect } from 'react';
import Modal from "react-bootstrap/Modal";
import LoaderSpinner from '../common/Loader';
import DataTable from '../common/DataTable';
import { ReconciliationTransactionDetailsColumns, numOfPage } from '../../constant';
import moment from 'moment';
import PropTypes from 'prop-types';
import BatchPagination from '../batch/BatchPagination';
import Form from 'react-bootstrap/Form';

/* istanbul ignore next */
const ReportModals = (props) => {
    const { show, handleCancel, selectedRecord, transactionDetails = [], transactionDetailsLoader = false, totalRecords = 0, onPaginationChange } = props;
    const [pageTitle, setPageTitle] = React.useState('');
    const [displayData, setDisplayData] = React.useState([]);
    const [paginationData, setPaginationData] = React.useState({
        currentPage: 1,
        pageSize: 30,
        totalPages: 1
    });
    
    const [sortingData, setSortingData] = React.useState({
        sortColumn: '',
        sortOrder: 'DESCENDING'
    });

    // Reset pagination and sorting when modal opens/closes
    useEffect(() => {
        if (show && (selectedRecord.key === 'month' || selectedRecord.key === 'matchedTrackingNumberCount' || selectedRecord.key === 'unMatchedTrackingNumberCount')) {
            setPaginationData({
                currentPage: 1,
                pageSize: 30,
                totalPages: 1
            });
            setSortingData({
                sortColumn: '',
                sortOrder: 'DESCENDING'
            });
        }
    }, [show, selectedRecord.key]);

    // Update total pages when totalRecords changes
    useEffect(() => {
        if (totalRecords > 0) {
            const calculatedTotalPages = Math.ceil(totalRecords / paginationData.pageSize);
            setPaginationData(prev => ({
                ...prev,
                totalPages: calculatedTotalPages
            }));
        }
    }, [totalRecords, paginationData.pageSize]);


    useEffect(() => {
        if (selectedRecord.key === 'unMatchedTrackingNumberCount') {
            setPageTitle(`Unmatched Tracking - ${selectedRecord.monthName} ${selectedRecord.year}`);
        } else if (selectedRecord.key === 'matchedTrackingNumberCount') {
            setPageTitle(`Matched Tracking - ${selectedRecord.monthName} ${selectedRecord.year}`);
        } else if (selectedRecord.key === 'month') {
            setPageTitle(`Transaction Details - ${selectedRecord.monthName} ${selectedRecord.year}`);
        } else {
            setPageTitle(`${selectedRecord.monthName} ${selectedRecord.year}`);
        }
    }, [selectedRecord]);

    useEffect(() => {
        if ((selectedRecord.key === 'month' || selectedRecord.key === 'matchedTrackingNumberCount' || selectedRecord.key === 'unMatchedTrackingNumberCount') && transactionDetails.length > 0) {
            // Format the transaction details for display
            const formattedData = transactionDetails.map((item, index) => ({
                ...item,
                id: (paginationData.currentPage - 1) * paginationData.pageSize + index + 1,
                shipmentId: item.shipmentId || 'N/A',
                trackingNumber: item.trackingNumber || 'N/A',
                createdDate: item.createdDate ? moment(item.createdDate).format('MM/DD/YYYY HH:mm:ss') : 'N/A',
                companySellerName: item.companySellerName || 'N/A',
                serviceName: item.serviceName || 'N/A',
                packageName: item.packageName || 'N/A',
                orderNumber: item.orderNumber || 'N/A',
                rate: item.rate ? `$${item.rate.toFixed(2)}` : 'N/A',
                baseRate: item.baseRate ? `$${item.baseRate.toFixed(2)}` : 'N/A',
                carrierAdminFee: item.carrierAdminFee ? `$${item.carrierAdminFee.toFixed(2)}` : 'N/A',
                wmsAdminFee: item.wmsAdminFee ? `$${item.wmsAdminFee.toFixed(2)}` : 'N/A',
                transactionAmount: item.transactionAmount ? `$${item.transactionAmount.toFixed(2)}` : 'N/A',
                profit: item.profit ? `$${item.profit.toFixed(2)}` : 'N/A',
                isMatched: item.isMatched ? 'Yes' : 'No'
            }));
            setDisplayData(formattedData);
        } else {
            setDisplayData([]);
        }
    }, [transactionDetails, selectedRecord.key, paginationData.currentPage, paginationData.pageSize]);

    const handleSortingColumn = (key) => {
        
        let newSortOrder = sortingData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        
        setSortingData({
            sortColumn: key,
            sortOrder: newSortOrder,
        });

        // Reset to first page when sorting changes
        setPaginationData(prev => ({
            ...prev,
            currentPage: 1
        }));
        
        // Notify parent component to fetch new data with sorting
        if (onPaginationChange) {
            onPaginationChange({
                pageNumber: 1,
                pageSize: paginationData.pageSize,
                sortColumn: key,
                sortOrder: newSortOrder
            });
        }
    };

    // Handle page change
    const handlePageChange = (newPage) => {
        setPaginationData(prev => ({
            ...prev,
            currentPage: newPage
        }));
        
        // Notify parent component to fetch new data
        if (onPaginationChange) {
            onPaginationChange({
                pageNumber: newPage,
                pageSize: paginationData.pageSize,
                sortColumn: sortingData.sortColumn,
                sortOrder: sortingData.sortOrder
            });
        }
    };

    // Handle page size change
    const handlePageSizeChange = (newPageSize) => {
        setPaginationData(prev => ({
            ...prev,
            pageSize: newPageSize,
            currentPage: 1 // Reset to first page when changing page size
        }));
        
        // Notify parent component to fetch new data
        if (onPaginationChange) {
            onPaginationChange({
                pageNumber: 1,
                pageSize: newPageSize,
                sortColumn: sortingData.sortColumn,
                sortOrder: sortingData.sortOrder
            });
        }
    };

    return (
        <Modal
            {...props}
            size="xl"
            className="topUpModal productskuListing carrier-reconciliation-modal"
            centered
            backdrop="static"
            show={show}
            onHide={handleCancel}
        >
            <div className="top_modal_header_container no_mrg">
                <div>
                    <span>{pageTitle}</span>
                </div>
                <div className="modalDeleteWrapper">
                    <button
                        type="button"
                        onClick={() => handleCancel()}
                        className="btn-close"
                        aria-label="Close"
                    ></button>
                </div>
            </div>

            <div className="modal_container_rate_card pb-3 productList">
                {(() => {
                    let content;
                    if (selectedRecord.key === 'month' || selectedRecord.key === 'matchedTrackingNumberCount' || selectedRecord.key === 'unMatchedTrackingNumberCount') {
                        if (transactionDetailsLoader) {
                            content = (
                                <div className="text-center p-4">
                                    <LoaderSpinner />
                                    <p>Loading transaction details...</p>
                                </div>
                            );
                        } else if (displayData.length > 0) {
                            content = (
                                <>
                                    <div className="main_content_table_history">
                                        <div className="tableFixHead center-aligned-table modalTableDesign">
                                            <DataTable
                                                headers={ReconciliationTransactionDetailsColumns}
                                                tableData={displayData}
                                                handleSortingColumn={handleSortingColumn}
                                                tableDataStatus="SUCCESS"
                                                filterData={{
                                                    ...paginationData,
                                                    sortColumn: sortingData.sortColumn,
                                                    sortOrder: sortingData.sortOrder
                                                }}
                                            />
                                        </div>
                                    </div>
                                    {totalRecords > 0 && (
                                        <BatchPagination
                                            gridData={displayData}
                                            totalVisualRecords={displayData.length}
                                            numberOfPage={paginationData.pageSize}
                                            numOfPage={numOfPage}
                                            loader={transactionDetailsLoader}
                                            currentPage={paginationData.currentPage}
                                            totalPages={paginationData.totalPages}
                                            totalRecords={totalRecords}
                                            setCurrentPage={handlePageChange}
                                            setNumberOfPage={handlePageSizeChange}
                                        />
                                    )}
                                </>
                            );
                        } else {
                            content = (
                                <div className="text-center p-4">
                                    <p>No transaction details found for the selected data.</p>
                                </div>
                            );
                        }
                    } else {
                        content = (
                            <div className="text-center p-4">
                                <p>Feature under development for {selectedRecord.key} column.</p>
                            </div>
                        );
                    }
                    return content;
                })()}
            </div>
        </Modal>
    );
}

ReportModals.propTypes = {
    show: PropTypes.bool,
    handleCancel: PropTypes.func,
    showProductListingBox: PropTypes.bool,
    data: PropTypes.array,
    selectedRecord: PropTypes.object,
    transactionDetails: PropTypes.array,
    transactionDetailsLoader: PropTypes.bool,
    totalRecords: PropTypes.number,
    onPaginationChange: PropTypes.func
};

export default ReportModals;